module.exports = __webpack_public_path__ + "img/ferry-colored.669ef9f3.svg";